
import { Link } from "react-router-dom"
import { useState, useEffect } from "react";
import logo from "./assets/logo.svg"
import { useLocation } from "react-router-dom";
import contactsIcon from "./assets/contactsIcon.svg"
import iconSeguimiento from "./assets/iconSeguimiento.svg"
import iconAsesor from "./assets/iconAsesor.svg"
import iconPromotores from "./assets/iconPromotores.svg"
import iconCotizador from "./assets/iconCotizador.svg"
import iconAgenda from "./assets/iconAgenda.svg"
import iconVentas from "./assets/iconVentas.svg"
import iconClientes from "./assets/iconClientes.svg"
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { useNavigate } from 'react-router-dom';
import { UrlMulticotizador } from "../../config"
import { useWindowWidth } from "@react-hook/window-size";
import iconSetting from "./assets/iconSetting.svg"
import iconOrganizacion from "./assets/iconOrganizacion.svg"; // As
import {
   CantainerNavbar,
   IconItem,
   LogoNavbar,
   ContainerListTextLink,
   ButtonRedirectLink
} from "./stylesNavbar";

const NavBar = ({ user, alertWelcome }) => {
   const location = useLocation();
   const navigate = useNavigate();
   const onlyWidth = useWindowWidth();
   const [open, setOpen] = useState(onlyWidth > 1100 ? true : false);

   useEffect(() => {
      console.log(open);
   }, [open]);

   useEffect(() => {
      if (user?.token && alertWelcome === true) {
         toast.success(`Bienvenido ${user.name} ${user.lastname}`)
         localStorage.removeItem('alert');
      }
   }, [user]);

   const cerrarSesion = async () => {
      localStorage.removeItem('user')
   }
   const handleLogut = async () => {
      cerrarSesion().then(() => {
         navigate('/login');
      });
   };

   return (
      user && (
         <CantainerNavbar onlyWidth={onlyWidth} open={open}>
            <Link to='/'>
               <LogoNavbar src={logo} alt='logo' />
            </Link>
            <ContainerListTextLink open={open} onlyWidth={onlyWidth}>
               <ToastContainer />
               <ButtonRedirectLink
                  style={{
                     backgroundColor: location.pathname === '/contacts' ? '#e0e2e7' : 'transparent',
                  }}
                  to='/contacts'>
                  <IconItem src={contactsIcon} /> {open ? 'Contactos' : null}
               </ButtonRedirectLink>
               {
                  user.type !== "Admin" &&
                     user.type !== "Supervisor" ?
                     null :
                     <ButtonRedirectLink
                        style={{
                           backgroundColor: location.pathname === '/asesores' ? '#e0e2e7' : 'transparent',
                        }}
                        to='/asesores'>
                        <IconItem src={iconAsesor} />  {open ? 'Asesores' : null}
                     </ButtonRedirectLink>
               }

               {
                  user.type !== "Admin" &&
                     user.type !== "Supervisor" || user.type === "Productor" ?

                     null :
                     <ButtonRedirectLink
                        style={{
                           backgroundColor: location.pathname === '/productores' ? '#e0e2e7' : 'transparent',
                        }}
                        to='/productores'>
                        <IconItem src={iconPromotores} />  {open ? 'Productores' : null}
                     </ButtonRedirectLink>
               }

               {
                  user.type !== "Admin" &&
                     user.type !== "Supervisor"
                     &&
                     user.type !== "Productor" &&
                     user.type !== "Asesor" ?
                     null
                     :
                     <ButtonRedirectLink
                        style={{
                           backgroundColor: location.pathname === '/seguimientos' ? '#e0e2e7' : 'transparent',
                        }}
                        to='/seguimientos'>
                        <IconItem src={iconSeguimiento} />  {open ? 'Seguimientos' : null}
                     </ButtonRedirectLink>
               }

               {
                  user.type !== "Admin" &&
                     user.type !== "Supervisor" &&
                     user.type !== "Productor" &&
                     user.type !== "Asesor" ?
                     null :
                     <ButtonRedirectLink
                        style={{
                           backgroundColor: location.pathname === '/clientes' ? '#e0e2e7' : 'transparent',
                        }}
                        to='/clientes'>
                        <IconItem src={iconClientes} />  {open ? 'Clientes' : null}
                     </ButtonRedirectLink>
               }

               {
                  user.type === "Productor" ?
                     null :
                     <ButtonRedirectLink
                        style={{
                           backgroundColor: location.pathname === '/cotizador' ? '#e0e2e7' : 'transparent',
                        }}
                        to={UrlMulticotizador} target="_blank"   >
                        <IconItem src={iconCotizador} /> {open ? 'Cotizador' : null}
                     </ButtonRedirectLink>
               }

               <ButtonRedirectLink
                  style={{
                     backgroundColor: location.pathname === '/agenda' ? '#e0e2e7' : 'transparent',
                  }}
                  to='/agenda'>
                  <IconItem src={iconAgenda} />  {open ? 'Agenda' : null}
               </ButtonRedirectLink>
               <ButtonRedirectLink
                  style={{
                     backgroundColor: location.pathname === '/cobranza' ? '#e0e2e7' : 'transparent',
                  }}
                  to='/cobranza'>
                  <IconItem src={iconVentas} />  {open ? 'Links' : null}
               </ButtonRedirectLink>
               {
                  user.type !== "Admin" &&
                     user.type !== "Supervisor" ?
                     null
                     :
                     <ButtonRedirectLink
                        style={{
                           backgroundColor: location.pathname === '/organizaciones' ? '#e0e2e7' : 'transparent',
                        }}
                        to='/organizaciones'>
                        <IconItem src={iconOrganizacion} />  {open ? 'Organizaciones' : null}
                     </ButtonRedirectLink>
               }
               {
                  user.type !== "Admin" &&
                     user.type !== "Supervisor" ?
                     null
                     :
                     <ButtonRedirectLink
                        style={{
                           backgroundColor: location.pathname === '/opciones' ? '#e0e2e7' : 'transparent',
                        }}
                        to='/opciones'>
                        <IconItem src={iconSetting} />  {open ? 'Preferencias' : null}
                     </ButtonRedirectLink>
               }

            </ContainerListTextLink>
         </CantainerNavbar>
      )
   )

}

export default NavBar